import { Box } from "@mui/material";
import { useEffect } from "react";
import useAPI from "../../../../../../api/hooks/useAPI";
import RemediationCollapseSection from "../../ControlRemediationDrawer/remediation/RemediationCollapseSection";
import { ArrowButton } from "../shared/ArrowButton";
import AffectedEntitiesSection from "./affectedEntities/AffectedEntitiesSection";
import MisconfigurationsSection from "./misconfigurations/MisconfigurationsSection";

export default function GroupedControlEntitiesSection({
  fullControl,
  misconfiguredComplexEntitiesByType,
  showDetailedAffectedEntities,
  setShowDetailedAffectedEntities,
  scrollDown,
  defaultCollapsed = false,
}) {
  const { trackEvent } = useAPI();

  const handleBackClick = () => {
    trackEvent(
      `User clicked the "back to overview" button from the affected entities in the drawer of control ${fullControl.control_id}`
    );
    setShowDetailedAffectedEntities(false);
    // When going back, we want to show the entities section
    if (scrollDown) {
      setTimeout(() => {
        scrollDown();
      }, 100);
    }
  };

  const handleMisconfigurationClick = (config_id) => {
    trackEvent(
      `User clicked the ${config_id} misconfiguration in the drawer of control ${fullControl.control_id}`
    );
    setShowDetailedAffectedEntities(config_id);
  };

  const misconfiguration = showDetailedAffectedEntities
    ? fullControl.misconfigurations.find(
        (misconfiguration) =>
          misconfiguration.misconfiguration_id === showDetailedAffectedEntities
      )
    : null;

  useEffect(() => {
    if (!misconfiguration && showDetailedAffectedEntities) {
      setShowDetailedAffectedEntities(false);
    }
  }, [misconfiguration, showDetailedAffectedEntities]);

  return (
    <Box>
      {showDetailedAffectedEntities && misconfiguration ? (
        <Box display="flex" flexDirection="column" gap={3}>
          <ArrowButton
            text="Back to Overview"
            onClick={handleBackClick}
            forward={false}
          />
          <AffectedEntitiesSection
            fullControl={fullControl}
            misconfiguration={misconfiguration}
          />
        </Box>
      ) : (
        <RemediationCollapseSection
          title={
            Object.values(misconfiguredComplexEntitiesByType).flat().length > 0
              ? "Who is affected?"
              : "What are the misconfigurations?"
          }
          defaultCollapsed={defaultCollapsed}
        >
          <MisconfigurationsSection
            fullControl={fullControl}
            misconfiguredComplexEntitiesByType={
              misconfiguredComplexEntitiesByType
            }
            handleMisconfigurationClick={handleMisconfigurationClick}
          />
        </RemediationCollapseSection>
      )}
    </Box>
  );
}
